'use strict';

angular.module('app').run(function (Iframe) {}) // jshint ignore:line

.factory('Iframe', function (DS) {
    return DS.defineResource({
        name: 'Iframe',
        endpoint: 'iframes',
        upsert: true
    });
});
